export type AuthFlow = "recovery" | "invite";

function appBaseUrl() {
  const configured = import.meta.env.VITE_APP_URL?.trim();
  const fallback = typeof window === "undefined" ? "http://localhost" : window.location.origin;
  return new URL(configured || fallback);
}

export function getAuthCallbackUrl(flow: AuthFlow) {
  const callback = new URL("/auth/callback", appBaseUrl());
  callback.searchParams.set("flow", flow);
  return callback.toString();
}

export function readAuthFlow(urlValue?: string): AuthFlow | null {
  const value = urlValue ?? (typeof window === "undefined" ? "http://localhost" : window.location.href);
  const url = new URL(value, "http://localhost");
  const queryFlow = url.searchParams.get("flow") || url.searchParams.get("type");
  const hash = new URLSearchParams(url.hash.replace(/^#/, ""));
  const hashFlow = hash.get("type") || hash.get("flow");
  const flow = queryFlow || hashFlow;
  return flow === "recovery" || flow === "invite" ? flow : null;
}

export function resolveAuthCallbackState(options: {
  flow: AuthFlow | null;
  loading: boolean;
  hasSession: boolean;
}) {
  if (options.loading) return "loading" as const;
  if (options.flow && options.hasSession) return "ready" as const;
  return "invalid" as const;
}
